'use client'
import { useRouter } from 'next/navigation'

export function useViewTransitionNavigate() {
  const router = useRouter()

  return (href: string) => {
    if ('startViewTransition' in document) {
      ;(document as any).startViewTransition(() => {
        router.push(href)
      })
    } else {
      router.push(href)
    }
  }
}
